import { World } from "./world";

// Uniform-grid spatial hash for neighbor / target queries. Rebuilt each tick
// from the World in entity-id order, so query results are deterministic.

export class SpatialHash {
  private cell: number;
  private cols: number;
  private rows: number;
  private buckets: number[][];

  constructor(worldW: number, worldH: number, cell = 48) {
    this.cell = cell;
    this.cols = Math.ceil(worldW / cell) + 1;
    this.rows = Math.ceil(worldH / cell) + 1;
    this.buckets = new Array(this.cols * this.rows);
    for (let i = 0; i < this.buckets.length; i++) this.buckets[i] = [];
  }

  private idx(cx: number, cy: number): number {
    return cy * this.cols + cx;
  }

  rebuild(w: World): void {
    for (let i = 0; i < this.buckets.length; i++) this.buckets[i].length = 0;
    for (let e = 0; e < w.count; e++) {
      if (!w.alive[e]) continue;
      const cx = Math.min(this.cols - 1, Math.max(0, (w.posX[e] / this.cell) | 0));
      const cy = Math.min(this.rows - 1, Math.max(0, (w.posY[e] / this.cell) | 0));
      this.buckets[this.idx(cx, cy)].push(e);
    }
  }

  /** Invoke cb for every entity within `radius` of (x,y). */
  query(x: number, y: number, radius: number, cb: (e: number) => void): void {
    const r = radius;
    const minCx = Math.max(0, ((x - r) / this.cell) | 0);
    const maxCx = Math.min(this.cols - 1, ((x + r) / this.cell) | 0);
    const minCy = Math.max(0, ((y - r) / this.cell) | 0);
    const maxCy = Math.min(this.rows - 1, ((y + r) / this.cell) | 0);
    for (let cy = minCy; cy <= maxCy; cy++) {
      for (let cx = minCx; cx <= maxCx; cx++) {
        const b = this.buckets[this.idx(cx, cy)];
        for (let i = 0; i < b.length; i++) cb(b[i]);
      }
    }
  }
}
